import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  const navColumn = [{
    label: t.nav_portfolio,
    href: '#portafolio'
  }, {
    label: t.nav_services,
    href: '#servicios'
  }, {
    label: t.nav_philosophy,
    href: '#filosofia'
  }, {
    label: t.nav_consult,
    href: '#consulta'
  }];
  return <footer className="bg-kinetic-footer pt-14 sm:pt-20 pb-8 sm:pb-10 px-5 sm:px-6 overflow-hidden" data-id="element-66" data-mp="36n3dnoiafsut">
      <div className="container mx-auto" data-id="element-67" data-mp="3ud7i1y3avwmv">
        <span className="text-xs uppercase tracking-widest text-white/30" data-id="element-68" data-mp="38z6mkvj6mzq">
          {t.footer_top_label}
        </span>

        <h2 className="font-heading text-3xl sm:text-5xl md:text-6xl font-black mt-4 break-words" data-id="element-69" data-mp="3ldu5gwjvqrxx">
          <span className="bg-gradient-to-r from-cyan-400 to-purple-500 bg-clip-text text-transparent" data-id="element-70" data-mp="3qbvmlbxqwh6r">
            Kinetic
          </span>
          <span className="text-white" data-id="element-71" data-mp="2eya1q2yx51r1"> Growth Studio</span>
          <span className="text-cyan-400" data-id="element-72" data-mp="2ezut5jpxs4ko">.</span>
        </h2>

        <p className="text-white/40 mt-4 text-sm sm:text-base" data-id="element-73" data-mp="3l90ozzfy550u">{t.footer_tagline}</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 sm:gap-8 mt-10 sm:mt-16 pb-10 sm:pb-16 border-b border-white/[0.08] max-w-lg" data-id="element-74" data-mp="3gapd7j63ckfz">
          <div data-id="element-75" data-mp="3v8htwendjevr">
            <span className="text-xs uppercase tracking-widest text-white/30 block mb-3" data-id="element-76" data-mp="3v91ans1afx87">
              {t.footer_nav_label}
            </span>
            <ul className="space-y-1" data-id="element-77" data-mp="82idvwen2ggf">
              {navColumn.map(link => <li key={link.href} data-id="element-78" data-mp="33xchtnnhqqe">
                  <a href={link.href} className="text-white/50 hover:text-white text-sm leading-loose transition-colors" data-id="element-79" data-mp="32w3duq73ebb">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          <div data-id="element-80" data-mp="qub81u5g27pq">
            <span className="text-xs uppercase tracking-widest text-white/30 block mb-3" data-id="element-81" data-mp="qu1jmb01s8m5">
              {t.footer_direct_label}
            </span>
            <ul className="space-y-1" data-id="element-82" data-mp="tvd0bu5d69g7">
              <li data-id="element-83" data-mp="twfmjorqrnps">
                <a href="mailto:hola@kineticgrowthstudio.com" className="text-white/50 hover:text-white text-sm leading-loose transition-colors break-all" data-id="element-84" data-mp="twxrd9sgza9b">
                  {t.footer_email}
                </a>
              </li>
              <li data-id="element-85" data-mp="18lk7vetu2824">
                <a href="https://wa.me/34634234462" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-white text-sm leading-loose transition-colors" data-id="element-86" data-mp="18m3qkxrb50h7">
                  WhatsApp: +34 634 234 462
                </a>
              </li>
              <li data-id="element-87" data-mp="1rj4xio4f9ans">
                <span className="text-white/50 text-sm leading-loose break-all" data-id="element-88" data-mp="1rhk4j2xr9zs1">
                  kineticgrowthstudio.com
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 mt-6 sm:mt-8 text-[11px] sm:text-xs text-white/25" data-id="element-89" data-mp="3tars0znivnp0">
          <span data-id="element-90" data-mp="25onde0jn77um">{t.footer_rights}</span>
          <span data-id="element-91" data-mp="25nltd6knfb0r">{t.footer_appointment}</span>
        </div>

        <p className="text-center text-white/15 text-xs mt-6 break-words" data-id="element-92" data-mp="21mjy10turj42">{t.footer_crafted}</p>
      </div>
    </footer>;
}